module["exports"] = [
  "#{Address.city_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/address/city.js
// module id = 1454
// module chunks = 1